module.exports = __webpack_public_path__ + "static/media/explore_03.47ad3fe4.jpg";